import styled from 'styled-components';

interface SelectProps {
  disabled?: boolean;
}

export const SimpleSelectContainer = styled.div<SelectProps>`
  position: relative;
  opacity: ${(p) => (p.disabled ? '0.4' : '1')};
`;

export const Label = styled.div`
  position: absolute;
  top: -17px;
  opacity: 0.7;
`;

export default SimpleSelectContainer;
